/* Barlen: alles via de zijwagen, met de bezorgdag.
   1. De winkelwagenpagina is er alleen nog zonder JavaScript. Wie op de winkelwagenpagina komt, gaat terug naar de
      vorige pagina (of de startpagina) en de zijwagen gaat daar open; dat regelt een klein script in de kop van de
      winkelwagenpagina, dit script opent de zijwagen bij aankomst. Links naar de winkelwagen openen de zijwagen.
   2. Het veld Bezorgdag in de zijwagen, boven Afrekenen, met een kalender in een venster van onderen. Afrekenen zonder
      dag (of met een dag die intussen niet meer kan) maakt het veld rood en opent de kalender. Bij Afrekenen gaan de
      kenmerken Bezorgdatum, Bezorgdag en Bezorging mee; na het bevestigen van een dag staan ze ook al op de winkelwagen.
   3. Met een kleed dat nog gemaakt wordt erbij: het vinkje "Alles in één keer bezorgen". Aan: geen dag nu. Uit: een dag
      voor het kleed op voorraad. De beginstand is een thema-instelling.
   De rekenregels staan in barlen-bezorgdag.js. Eén keer laden; de vlag voorkomt dat het twee keer start. */
(function () {
  'use strict';
  if (window.bcZijwagen) return;
  window.bcZijwagen = true;

  var BZ = window.BarlenBezorgdag;
  var INST = BZ ? BZ.instellingen : { aan: false, wagen: '/cart' };
  var WAGEN = INST.wagen || '/cart';
  var OPEN = 'bz-wagen-open', LAATSTE = 'bz-laatste', DAG = 'bz-dag', SAMEN = 'bz-samen';

  function lees(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function schrijf(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* niets */ } }
  function pad(u) { try { return new URL(u, window.location.href).pathname.replace(/\/$/, '') || '/'; } catch (e) { return ''; } }
  var WAGEN_PAD = pad(WAGEN);
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sjabloon(naam) { return document.body && document.body.classList.contains('template-' + naam); }

  /* ================================================================ 1. alles via de zijwagen */

  /* De laatste gewone pagina, als terugweg voor wie op de winkelwagenpagina komt. */
  function onthoudPagina() {
    if (sjabloon('cart') || sjabloon('404') || sjabloon('password')) return;
    if (/^\/(account|checkout|checkouts|challenge)(\/|$)/.test(window.location.pathname)) return;
    schrijf(LAATSTE, window.location.pathname + window.location.search);
  }

  function runtime() {
    if (window.ajaxCart && typeof window.ajaxCart.open === 'function') return Promise.resolve(window.ajaxCart);
    var thema = window.XclusiveTheme;
    if (thema && typeof thema.ensureCustomAsyncRuntime === 'function') return thema.ensureCustomAsyncRuntime();
    return Promise.reject(new Error('zijwagen niet beschikbaar'));
  }
  /* Opent de zijwagen. Navigeert zelf nooit; geeft terug of het lukte. Lukt het de eerste keer niet (de inhoud kon
     niet worden opgehaald), dan één keer opnieuw, na een gewoon verzoek aan de winkelwagen. */
  function openWagen() {
    var poging = function () { return runtime().then(function (c) { return c.open({ redirect: false }); }).then(function (open) { return !!open; }).catch(function () { return false; }); };
    return poging().then(function (open) {
      if (open) return true;
      return fetch(WAGEN, { credentials: 'same-origin' }).catch(function () { return null; }).then(poging);
    });
  }

  /* Aankomst na de winkelwagenpagina: de zijwagen openen. Niet op de winkelwagenpagina zelf: die stuurt door, en dit
     script kan daar nog draaien voordat de bezoeker weg is. */
  function bijAankomst() {
    if (sjabloon('cart')) return;
    var hash = window.location.hash === '#winkelwagen';
    if (lees(OPEN) !== '1' && !hash) return;
    schrijf(OPEN, null);
    if (hash) { try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (e) { /* niets */ } }
    openWagen();
  }

  /* Een link naar de winkelwagen opent de zijwagen. Een nieuw tabblad (Ctrl, middelste knop) blijft een gewone link. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (sjabloon('cart')) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download')) return;
    var venster = (a.getAttribute('target') || '').toLowerCase();
    if (venster && venster !== '_self') return;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (x) { return; }
    if (url.origin !== window.location.origin || (url.pathname.replace(/\/$/, '') || '/') !== WAGEN_PAD) return;
    if (a.hasAttribute('data-panel') && window.ajaxCart) return; /* dat doet het thema zelf */
    e.preventDefault();
    openWagen().then(function (open) { if (!open) window.location.href = a.href; });
  }, true);

  /* ================================================================ 2. het veld Bezorgdag */
  var cart = null;
  var st = { dag: undefined, samen: undefined, fout: '', knipper: false, venster: null };
  var MAAND = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  function blok() { return cart ? cart.querySelector('[data-bz]') : null; }
  function laterVan(b) { try { var l = JSON.parse(b.getAttribute('data-bz-later') || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function samenStandaard(b) { return b.getAttribute('data-bz-samen-standaard') === 'true'; }
  function gemengd(b) { return !!b.querySelector('[data-bz-samen]'); }
  function samenNu(b) { return gemengd(b) && (st.samen === null ? samenStandaard(b) : st.samen); }
  /* De keuze in de sessie hoort bij één winkelwagen (een vingerafdruk ervan); bij een nieuwe winkelwagen telt ze niet. */
  function wagenId() { var b = blok(); return b ? (b.getAttribute('data-bz-wagen') || '') : ''; }
  function leesKeuze(sleutel) {
    var w = (lees(sleutel) || '').split('|');
    return w.length === 2 && w[1] === wagenId() ? w[0] : null;
  }
  function schrijfKeuze(sleutel, waarde) { schrijf(sleutel, waarde == null ? null : waarde + '|' + wagenId()); }

  function beginStand(b) {
    var ms = BZ.nu(), s = BZ.schema;
    if (st.dag === undefined) {
      var d = BZ.leesVkDatum(leesKeuze(DAG));
      if (d === null) {
        d = BZ.leesVkDatum(b.getAttribute('data-bz-datum'));
        if (d !== null && !BZ.geldig(d, ms, s)) d = null;
      }
      st.dag = d;
    }
    if (st.samen === undefined) {
      var w = leesKeuze(SAMEN);
      if (w === '1' || w === '0') st.samen = w === '1';
      else {
        var k = b.getAttribute('data-bz-bezorging');
        st.samen = k === 'Alles samen' ? true : k === 'In twee keer' ? false : null;
      }
    }
  }

  function kenmerkenNu(b, ms) {
    var dag = st.dag !== null && BZ.geldig(st.dag, ms, BZ.schema) ? st.dag : null;
    var k = BZ.vkKenmerken({ dag: dag, gemengd: gemengd(b), samen: samenNu(b) });
    return { Bezorgdatum: k.Bezorgdatum || '', Bezorgdag: k.Bezorgdag || '', Bezorging: k.Bezorging || '' };
  }
  /* De verborgen velden zitten in het afrekenformulier, net na het blok. */
  function zetVelden(b, k) {
    Array.prototype.forEach.call(cart.querySelectorAll('input[data-bz-kenmerk]'), function (i) {
      var w = k[i.getAttribute('data-bz-kenmerk')];
      if (w != null && i.value !== w) i.value = w;
    });
  }

  /* De klok van de server alleen opvragen als het veld er is (één keer; het antwoord wordt een half uur bewaard). */
  var klokGevraagd = false;
  function teken() {
    var b = blok();
    if (!b || !BZ) { if (st.venster) sluitVenster(false); return; }
    if (!klokGevraagd) {
      klokGevraagd = true;
      BZ.klok().then(function (verschil) { if (verschil && blok()) teken(); });
    }
    beginStand(b);
    var ms = BZ.nu(), s = BZ.schema;
    var lijst = BZ.kiesbaar(ms, s), eerst = lijst[0];
    var samen = samenNu(b);
    var verlopen = st.dag !== null && !BZ.geldig(st.dag, ms, s);
    var fout = st.fout || (verlopen ? BZ.magAfrekenen({ dag: st.dag }, ms, s).melding : '');
    var gekozen = st.dag !== null && !verlopen;

    var vak = b.querySelector('[data-bz-vak]');
    var veld = b.querySelector('[data-bz-veld]');
    var waarde = b.querySelector('[data-bz-waarde]');
    var foutEl = b.querySelector('[data-bz-fout]');
    if (vak) vak.hidden = samen;
    if (veld && waarde) {
      var html = gekozen ? esc(BZ.hoofdletter(BZ.datumTekst(st.dag))) : 'Kies een dag <small>vanaf ' + esc(BZ.datumTekst(eerst, 'kort')) + '</small>';
      if (waarde.innerHTML !== html) waarde.innerHTML = html;
      veld.classList.toggle('bz-gekozen', gekozen && !fout);
      veld.classList.toggle('bz-fout', !!fout);
      veld.classList.toggle('bz-knippert', !!fout && st.knipper);
      if (fout) { veld.setAttribute('aria-invalid', 'true'); veld.setAttribute('aria-describedby', 'bz-fout'); }
      else { veld.removeAttribute('aria-invalid'); veld.removeAttribute('aria-describedby'); }
      veld.setAttribute('aria-expanded', st.venster ? 'true' : 'false');
    }
    if (foutEl) {
      if (foutEl.textContent !== fout) foutEl.textContent = fout;
      foutEl.hidden = !fout || samen;
    }
    var vink = b.querySelector('[data-bz-samen]');
    if (vink) {
      vink.checked = samen;
      var dagSamen = BZ.samenVanaf(ms, laterVan(b), s);
      var wanneer = b.querySelector('[data-bz-wanneer]');
      var t = dagSamen !== null ? ', vanaf ' + BZ.datumTekst(dagSamen, 'dagmaand') : ', als alles klaar is';
      if (wanneer && wanneer.textContent !== t) wanneer.textContent = t;
      var uitleg = b.querySelector('[data-bz-uitleg]');
      if (uitleg) uitleg.hidden = !samen;
    }
    zetVelden(b, kenmerkenNu(b, ms));
    if (st.venster) { if (samen) sluitVenster(false); else tekenVenster(); }
  }

  /* ---------- het venster met de kalender */
  function laag() { return cart ? cart.querySelector(':scope > [data-bz-laag]') : null; }
  function plaats(l) {
    var r = cart.getBoundingClientRect();
    l.style.left = Math.round(r.left) + 'px';
    l.style.width = Math.round(r.width) + 'px';
  }
  function rest(aan) {
    Array.prototype.forEach.call(cart.children, function (kind) {
      if (kind.hasAttribute('data-bz-laag')) return;
      if (aan) { if (!kind.inert) { kind.inert = true; kind.setAttribute('data-bz-inert', ''); } }
      else if (kind.hasAttribute('data-bz-inert')) { kind.inert = false; kind.removeAttribute('data-bz-inert'); }
    });
  }
  function maandStart(dag) { var x = BZ.datumVan(dag); return BZ.dagNummer(x.j, x.m, 1); }
  function dagenInMaand(j, m) { return new Date(Date.UTC(j, m, 0)).getUTCDate(); }

  function vensterHtml() {
    var v = st.venster, ms = BZ.nu(), s = BZ.schema;
    var lijst = BZ.kiesbaar(ms, s), kan = {};
    lijst.forEach(function (d) { kan[d] = true; });
    var eerst = lijst[0], laatst = lijst[lijst.length - 1];
    var f = BZ.datumVan(v.kal);
    var start = BZ.dagNummer(f.j, f.m, 1);
    var inMaand = dagenInMaand(f.j, f.m);
    var voor = BZ.weekdag(start) - 1;
    var vandaag = BZ.wandklok(ms).dag;
    var rijen = '', cel = 0;
    for (var w = 0; w < 6 && cel < voor + inMaand; w++) {
      rijen += '<tr>';
      for (var k = 0; k < 7; k++, cel++) {
        var nr = cel - voor + 1;
        if (nr < 1 || nr > inMaand) { rijen += '<td class="bz-leeg" aria-hidden="true"></td>'; continue; }
        var d = start + nr - 1, ok = !!kan[d];
        var label = BZ.datumTekst(d) + (ok ? '' : ', geen bezorging');
        rijen += '<td role="gridcell" tabindex="' + (d === v.kal ? 0 : -1) + '" data-bz-cel="' + d + '" aria-label="' + esc(label) + '" aria-selected="' + (v.sel === d) + '"' + (ok ? '' : ' aria-disabled="true"') + (d === vandaag ? ' aria-current="date"' : '') + '>' + nr + '</td>';
      }
      rijen += '</tr>';
    }
    var eersteMaand = maandStart(eerst), laatsteMaand = maandStart(laatst);
    var bevestig = v.sel !== null
      ? '<button type="button" class="bz-bevestig" data-bz-bevestig>Bevestig ' + esc(BZ.datumTekst(v.sel)) + '</button>'
      : '<button type="button" class="bz-bevestig" data-bz-bevestig aria-disabled="true">Kies een dag</button>';
    return '<div class="bz-achter" data-bz-sluit></div>'
      + '<section class="bz-sheet" role="dialog" aria-modal="true" aria-labelledby="bz-titel" aria-describedby="bz-zin" data-bz-sheet>'
      + '<div class="bz-sheetkop"><h2 class="bz-titel" id="bz-titel">Kies je gewenste bezorgdag</h2><button type="button" class="bz-sluit" data-bz-sluit aria-label="Sluiten"><span aria-hidden="true">×</span></button></div>'
      + '<p class="bz-zin" id="bz-zin">Je tekent bij ontvangst, dus kies een dag dat je thuis bent.</p>'
      + (v.melding ? '<p class="bz-melding" role="alert">' + esc(v.melding) + '</p>' : '')
      + '<div class="bz-kalkop">'
      + '<button type="button" class="bz-kalknop" data-bz-maand="-1" aria-label="Vorige maand"' + (start <= eersteMaand ? ' aria-disabled="true"' : '') + '><span aria-hidden="true">‹</span></button>'
      + '<h3 class="bz-maand" id="bz-maand" aria-live="polite">' + MAAND[f.m - 1] + ' ' + f.j + '</h3>'
      + '<button type="button" class="bz-kalknop" data-bz-maand="1" aria-label="Volgende maand"' + (start >= laatsteMaand ? ' aria-disabled="true"' : '') + '><span aria-hidden="true">›</span></button>'
      + '</div>'
      + '<table class="bz-rooster" role="grid" aria-labelledby="bz-maand"><thead><tr>'
      + '<th scope="col" abbr="maandag">ma</th><th scope="col" abbr="dinsdag">di</th><th scope="col" abbr="woensdag">wo</th><th scope="col" abbr="donderdag">do</th><th scope="col" abbr="vrijdag">vr</th><th scope="col" abbr="zaterdag">za</th><th scope="col" abbr="zondag">zo</th>'
      + '</tr></thead><tbody>' + rijen + '</tbody></table>'
      + bevestig
      + '</section>';
  }
  function tekenVenster() {
    var l = laag();
    var nieuw = !l;
    if (nieuw) {
      l = document.createElement('div');
      l.className = 'bz-laag';
      l.setAttribute('data-bz-laag', '');
      l.addEventListener('keydown', toets);
      cart.appendChild(l);
    }
    plaats(l);
    var html = vensterHtml();
    if (l.getAttribute('data-html') !== html) {
      var fokus = document.activeElement && l.contains(document.activeElement) ? sleutelVan(document.activeElement) : null;
      l.innerHTML = html;
      l.setAttribute('data-html', html);
      if (fokus) herstelFocus(l, fokus);
    }
    rest(true);
  }
  function sleutelVan(el) {
    if (el.hasAttribute('data-bz-cel')) return '[data-bz-cel][tabindex="0"]';
    if (el.hasAttribute('data-bz-maand')) return '[data-bz-maand="' + el.getAttribute('data-bz-maand') + '"]';
    if (el.hasAttribute('data-bz-bevestig')) return '[data-bz-bevestig]';
    if (el.classList.contains('bz-sluit')) return '.bz-sluit';
    return null;
  }
  function herstelFocus(l, sleutel) {
    var el = l.querySelector(sleutel);
    if (el && getComputedStyle(el).visibility !== 'hidden') el.focus();
    else focusCel();
  }
  function focusCel() {
    var l = laag();
    var c = l && l.querySelector('td[data-bz-cel][tabindex="0"]');
    if (c) c.focus();
  }

  function openVenster(melding) {
    var ms = BZ.nu(), lijst = BZ.kiesbaar(ms, BZ.schema);
    var dag = st.dag !== null && lijst.indexOf(st.dag) > -1 ? st.dag : null;
    st.venster = { kal: dag !== null ? dag : lijst[0], sel: dag, melding: melding || '' };
    teken();
    focusCel();
  }
  function sluitVenster(focusTerug) {
    st.venster = null;
    var l = laag();
    if (l) l.remove();
    if (cart) rest(false);
    if (blok()) teken();
    if (focusTerug) { var veld = cart && cart.querySelector('[data-bz-veld]'); if (veld && !veld.closest('[hidden]')) veld.focus(); }
  }
  function kiesCel(dag) {
    var v = st.venster;
    if (!v) return;
    v.kal = dag;
    if (BZ.kiesbaar(BZ.nu(), BZ.schema).indexOf(dag) > -1) v.sel = dag;
    teken();
    focusCel();
  }
  function bevestig() {
    var v = st.venster;
    if (!v || v.sel === null) return;
    st.dag = v.sel;
    schrijfKeuze(DAG, BZ.vkDatum(st.dag));
    st.fout = '';
    st.knipper = false;
    sluitVenster(true);
    bewaar();
  }
  function naarMaand(stap) {
    var v = st.venster;
    if (!v) return;
    var f = BZ.datumVan(v.kal), m = f.m + stap, j = f.j + (m > 12 ? 1 : m < 1 ? -1 : 0), mm = ((m + 11) % 12) + 1;
    var eersteVanMaand = BZ.dagNummer(j, mm, 1);
    var lijst = BZ.kiesbaar(BZ.nu(), BZ.schema);
    var keuze = null;
    for (var i = 0; i < lijst.length; i++) if (lijst[i] >= eersteVanMaand) { keuze = lijst[i]; break; }
    v.kal = keuze !== null && keuze < eersteVanMaand + dagenInMaand(j, mm) ? keuze : eersteVanMaand;
    teken();
  }

  /* ---------- kenmerken op de winkelwagen zetten (na Bevestig en bij het vinkje) */
  var schrijfKlok = null, geschreven = null;
  function bewaar() {
    clearTimeout(schrijfKlok);
    schrijfKlok = setTimeout(function () {
      var b = blok();
      if (!b) return;
      var k = kenmerkenNu(b, BZ.nu());
      var sleutel = JSON.stringify(k);
      if (sleutel === geschreven) return;
      geschreven = sleutel;
      var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
      var doe = function () { return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: k }) }); };
      doe().then(function (r) {
        if (r.status !== 401) return r;
        return fetch(WAGEN, { credentials: 'same-origin' }).then(doe, doe);
      }).then(function (r) { if (!r || !r.ok) geschreven = null; }).catch(function () { geschreven = null; });
    }, 250);
  }

  /* ---------- Afrekenen: de dag opnieuw nakijken */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !cart || !cart.contains(form) || !form.classList.contains('wg-afrekenen')) return;
    var b = blok();
    if (!b || !BZ) return;
    beginStand(b);
    var ms = BZ.nu();
    var mag = BZ.magAfrekenen({ dag: st.dag, gemengd: gemengd(b), samen: samenNu(b) }, ms, BZ.schema);
    if (!mag.mag) {
      e.preventDefault();
      e.stopImmediatePropagation();
      st.fout = mag.melding;
      st.knipper = true;
      if (mag.reden === 'verlopen') { st.dag = null; schrijfKeuze(DAG, null); }
      openVenster(mag.melding);
      return;
    }
    zetVelden(b, kenmerkenNu(b, ms));
  }, true);

  /* ---------- klikken, kiezen en toetsen */
  document.addEventListener('click', function (e) {
    if (!cart || !e.target || !e.target.closest) return;
    var t = e.target.closest('[data-bz-veld], [data-bz-sluit], [data-bz-cel], [data-bz-maand], [data-bz-bevestig]');
    if (!t || !cart.contains(t)) return;
    if (t.hasAttribute('data-bz-veld')) { e.preventDefault(); openVenster(''); return; }
    if (t.hasAttribute('data-bz-sluit')) { e.preventDefault(); sluitVenster(true); return; }
    if (t.hasAttribute('data-bz-cel')) { if (t.getAttribute('aria-disabled') !== 'true') kiesCel(Number(t.getAttribute('data-bz-cel'))); return; }
    if (t.hasAttribute('data-bz-maand')) { if (t.getAttribute('aria-disabled') !== 'true') naarMaand(Number(t.getAttribute('data-bz-maand'))); return; }
    if (t.hasAttribute('data-bz-bevestig')) { if (t.getAttribute('aria-disabled') !== 'true') bevestig(); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!cart || !t || !t.hasAttribute || !t.hasAttribute('data-bz-samen') || !cart.contains(t)) return;
    st.samen = t.checked;
    schrijfKeuze(SAMEN, t.checked ? '1' : '0');
    st.fout = '';
    st.knipper = false;
    teken();
    bewaar();
  });
  /* Toetsen in het venster. Deze luisteraar hangt aan het venster zelf, zodat Escape alleen het venster sluit en niet
     ook de zijwagen (het thema sluit panelen met Escape op het hele document). */
  function toets(e) {
    var l = laag();
    if (!l || !l.contains(e.target)) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); sluitVenster(true); return; }
    if (e.key === 'Tab') {
      var items = Array.prototype.filter.call(l.querySelectorAll('button, td[tabindex="0"]'), function (x) { return x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden'; });
      if (!items.length) return;
      e.preventDefault();
      var i = items.indexOf(e.target);
      var volgende = e.shiftKey ? (i <= 0 ? items.length - 1 : i - 1) : (i < 0 || i === items.length - 1 ? 0 : i + 1);
      items[volgende].focus();
      return;
    }
    var t = e.target;
    if (!t.hasAttribute('data-bz-cel')) return;
    var d = Number(t.getAttribute('data-bz-cel'));
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (t.getAttribute('aria-disabled') !== 'true') kiesCel(d); return; }
    var doel = null;
    var pijl = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
    if (pijl) doel = d + pijl;
    else if (e.key === 'Home') doel = d - (BZ.weekdag(d) - 1);
    else if (e.key === 'End') doel = d + (7 - BZ.weekdag(d));
    else if (e.key === 'PageDown' || e.key === 'PageUp') {
      var f = BZ.datumVan(d), m = f.m + (e.key === 'PageDown' ? 1 : -1), j = f.j + (m > 12 ? 1 : m < 1 ? -1 : 0), mm = ((m + 11) % 12) + 1;
      doel = BZ.dagNummer(j, mm, Math.min(f.d, dagenInMaand(j, mm)));
    }
    if (doel === null) return;
    e.preventDefault();
    var lijst = BZ.kiesbaar(BZ.nu(), BZ.schema);
    var min = maandStart(lijst[0]);
    var laatst = BZ.datumVan(lijst[lijst.length - 1]);
    var max = BZ.dagNummer(laatst.j, laatst.m, dagenInMaand(laatst.j, laatst.m));
    st.venster.kal = Math.max(min, Math.min(max, doel));
    teken();
    focusCel();
  }

  /* ---------- de zijwagen volgen: nieuwe inhoud, openen en sluiten */
  function focusBijOpenen() {
    setTimeout(function () {
      if (!cart || !cart.classList.contains('toggle')) return;
      var a = document.activeElement;
      if (a && cart.contains(a) && a.getAttribute('aria-hidden') !== 'true') return;
      var kop = cart.querySelector('[data-wg-kopfocus]');
      if (kop) { try { kop.focus({ preventScroll: true }); } catch (x) { kop.focus(); } }
    }, 250);
  }
  function koppel() {
    cart = document.getElementById('cart');
    if (!cart || cart.hasAttribute('data-bz-gekoppeld')) return;
    cart.setAttribute('data-bz-gekoppeld', '');
    new MutationObserver(function (lijst) {
      var eigen = lijst.every(function (m) {
        return Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.hasAttribute('data-bz-laag'); })
          && Array.prototype.every.call(m.removedNodes, function (n) { return n.nodeType === 1 && n.hasAttribute('data-bz-laag'); });
      });
      if (eigen) return;
      teken();
      if (st.venster) focusCel();
    }).observe(cart, { childList: true });
    var open = cart.classList.contains('toggle');
    new MutationObserver(function () {
      var nu = cart.classList.contains('toggle');
      if (nu === open) return;
      open = nu;
      if (!open && st.venster) sluitVenster(false);
      if (open) { teken(); focusBijOpenen(); }
    }).observe(cart, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () { var l = laag(); if (l) plaats(l); });
    if (blok()) teken();
  }

  function start() {
    onthoudPagina();
    koppel();
    bijAankomst();
    if (BZ) {
      setInterval(function () { if (!document.hidden && cart && cart.classList.contains('toggle')) teken(); }, 30000);
    }
  }
  /* Terug uit de bfcache van de browser: de dag opnieuw nakijken (de klok kan over de besteltijd heen zijn), en de
     zijwagen openen als de bezoeker van de winkelwagenpagina terugkomt. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    bijAankomst();
    if (blok()) teken();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
